import React from "react";

// import { real_date } from "../../../services/convert/date";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_trainings } from "../../../services/apis/training";
import { real_date } from "../../../services/convert/date";

const Training = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ request }) => request.loading);
  const trainings = useAppSelector(({ training }) => training.trainings);

  const onLoad = React.useCallback(() => {
    get_trainings(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const getStatusColor = (statusId: string) => {
    switch (statusId?.toLowerCase()) {
      case "1":
        return "bg-primary-100/50 text-primary-800";
      case "0":
        return "bg-red-100/50 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };
  return (
    <div>
      <h4 className="text-left text-[17px] font-bold mb-3">Training</h4>

      {loading ? (
        <div className="bg-white rounded-xl shadow-md flex justify-center items-center h-[200px]">
          <span>Loading...</span>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 bg-muted/30">
                <th className="px-6 py-3 text-left text-sm font-semibold text-foreground">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-foreground">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-foreground">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="w-full p-4">
              {trainings &&
                trainings.slice(0, 5).map((item) => (
                  <tr
                    key={item.id}
                    className="border-b border-gray-100 hover:bg-muted/50 transition-colors"
                  >
                    <td className="px-6 py-3">
                      <span className="text-sm font-medium text-foreground">
                        {item.name || "Untitled"}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      <span
                        className={`text-xs font-medium rounded-full px-2 py-1 ${getStatusColor(item.status || "")}`}
                      >
                        {item.status === "1" ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      <span className="text-sm text-muted-foreground whitespace-nowrap">
                        {real_date(item.date)}
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Training;
